module.exports = __webpack_public_path__ + "static/ashraf-5b8b887bf5e40e9bb153fc048836208f.jpg";